import {_, React, classNames, useAsync, useLocalStore, useEffect, jsonComputedOptions, observer, Fragment, Popover2} from '@api'
import {MenuItem, Popover, Menu, Button, Icon, MenuDivider, OverflowList, Spinner} from '@blueprintjs/core'
import {KeyboardArrowRight} from '@material-ui/icons'
import {IPlanDefinition} from '@stores/vlp/store/VLPHierarchyStore'
import {action, computed, observable, reaction, toJS} from 'mobx'
import {nav, StoresInstance, FlexLayoutTabSpinnerIcon} from '@stores'
import * as css from './SeasonSelectorBreadcrumbs.css'
import {LazyImage} from 'centric-ui-components'
import {SeasonSelectorContext, useSeasonSelectorStore, CatalogSeasonSelectors, HeaderSyncIndicator, useStores, useVipLocalStore, VipLocalStore} from '@design-board'

export const SeasonSelectorNavigation = observer(function SeasonSelectorNavigation() {
  const {workspaces: {workspaceConfig}} = useStores()
  return workspaceConfig?.seasonIndex
         ? <SeasonSelectorBreadcrumbs/>
         : <CatalogSeasonSelectors align='left'/>
})

interface MyProps {
  onDoubleClick?: React.MouseEventHandler<HTMLDivElement>
  className?: string
}

export const SeasonSelectorBreadcrumbs = observer<MyProps>(function SeasonSelectorBreadcrumbs({onDoubleClick, className}) {
  useEffect(() => reaction(
    () => ({season: nav.params.season, category1: nav.params.category1}),
    () => this.store.reset(),
    {name: `Reset breadcrumbs if URL changes`}), [])

  const {strings, vlp, catalog: {seasonSelector}} = useStores()
  if (!seasonSelector) return null

  const {dirty, commitNav, selectedPlans, isLeafFolderSelected} = seasonSelector

  //console.log(selectedFolder, leafLevel, selectedFolder[leafLevel - 1])
  return (
    <SeasonSelectorContext.Provider value={seasonSelector}>
      <div className={classNames(className, css.root)}
           data-type='SeasonSelectorBreadcrumbs'
           onMouseLeave={commitNav}
           onDoubleClick={onDoubleClick}>
        {/*<BreadcrumbOverflowList />*/}

        {vlp.hierarchy.hasVlpHierarchy ?
         <Fragment>
           <VlpPlansBreadcrumb/>
           {!_.isEmpty(selectedPlans) && <VlpFolderBreadcrumbs/>}
           {isLeafFolderSelected && <VlpCollectionBreadcrumb/>}

           {dirty && <div className={css.navCommit}>
             {/*<Button text='Undo' rightIcon={<Spinner size={20} />} minimal onClick={cancelNav} />*/}
         <Button title={strings.go} icon={<FlexLayoutTabSpinnerIcon />} minimal onClick={commitNav}/>
			 </div>}
         </Fragment>
                                       : null}
      </div>
    </SeasonSelectorContext.Provider>
  )
})

const BreadcrumbOverflowList = observer(() => {
  return <OverflowList
    className={css.overflowList}
    overflowRenderer={(items) => {
      console.log(items)
      return <Popover2 interactionKind='click' content={<Menu>
        <MenuItem text='Plan:  Some Plan'>
          <MenuItem text='Folder 1:'/>
          <MenuItem text='Folder 2:'/>
        </MenuItem>
        <MenuItem text='Folder 1:'/>
        <MenuItem text='Folder 2:'/>
      </Menu>}>
        <Button minimal rightIcon='caret-down' text='...'/>
      </Popover2>
    }}
    visibleItemRenderer={(item, i) => {
      console.log(item, i)
      return <Fragment key={i}>
        <div>Visible Item</div>
      </Fragment>
    }}
    items={[
      {key: 1, icon: 'folder-close', text: 'Users'},
      {key: 2, icon: 'folder-close', text: 'Janet'},
      {key: 3, icon: 'document', text: 'image.jpg'}
    ]}
  />
})

const VlpPlansBreadcrumb = observer(function VlpPlansBreadcrumb() {
  const {
    onClickBreadcrumb, onAddHierarchy, selected, selectedPlans, onContextMenu,
    vlp: {
      hierarchy,
      hierarchy: {
        clear,
        availablePlans
      }
    },
    strings, catalog: {
      workspaceConfig: {addHierarchyItem},
      seasonSelector,
      seasonSelector: {_counts: {loading, plans: counts}, openBreadcrumb, onOpenBreadcrumb, onCloseBreadcrumb}
    }
  } = useSeasonSelectorStore()

  return !availablePlans
         ? <Button minimal
                   text='Loading...'/>
         : <Popover2
           key='plan'
           minimal
           //usePortal={true}
           interactionKind='hover'
           position='bottom-left'
           onOpening={onOpenBreadcrumb}
           isOpen={openBreadcrumb?.type == 'plan'}
           onInteraction={nextOpenState => {
             if (nextOpenState) {
               seasonSelector.openBreadcrumb = {type: 'plan'}
             } else if (seasonSelector.openBreadcrumb?.type === 'plan') {
               seasonSelector.openBreadcrumb = null
             }
           }}
           onClose={onCloseBreadcrumb}
           content={
             <Menu className={classNames(css.menuItem)}>
               {availablePlans.length === 0
                ? <div className={css.notFoundText}>Plans not found</div>
                : _.orderBy<IPlanDefinition>(availablePlans, p => p.name)
                  .map(p => (
                    <MenuItem
                      key={p.id}
                      data-id={p.id}
                      text={p.name ? p.name : strings.noValue}
                      shouldDismissPopover={availablePlans.length === 1}
                      onContextMenu={onContextMenu(p, 'plan')}
                      //disabled={countsDict && !countsDict[p.id]}
                      className={css.menuItem}
                      labelElement={counts && <div className={css.count}>({_.isEmpty(counts) && loading ? '...' : counts[p.id] ?? 0})</div>}
                      onClick={onClickBreadcrumb('plan', p)}
                      icon={_.includes(selected.plans, p.id) ? 'tick' : 'blank'}
                    />
                  ))}
               {selectedPlans?.length > 0 &&
		        <Fragment>
			        <MenuDivider/>
			        <MenuItem className={classNames(css.menuItem)} icon='clean' text={strings.clearSelection} onClick={clear}/>
		        </Fragment>}

               {addHierarchyItem && <Fragment> <MenuDivider/> <MenuItem key={'addPlan'} icon='add' className={classNames(css.menuItem)} text={'New Plan'} onClick={() => onAddHierarchy('plan')}/> </Fragment>}
             </Menu>
           }
         >
           <Button //rightIcon={season ? undefined : 'caret-down'}
             minimal
             text={!_.isEmpty(selectedPlans) ? _.sortBy(selectedPlans.map(p => p.name)).join(', ') : availablePlans.length ? 'Plan' : 'No Plans'}
             rightIcon='caret-down'
           />
         </Popover2>
})

const VlpFolderBreadcrumbs = observer(function VlpFolderBreadcrumbs() {
  const {
    catalog: {seasonSelector: {deepestSelectedFolderIndex, deepestFolderIndex,}}
  } = useStores()

  return <Fragment>
    {_.range(0, Math.min(deepestSelectedFolderIndex + 1, deepestFolderIndex + 1))
      .map(i => {
        return (
          <VlpFolderBreadcrumb key={i} index={i}/>
        )
      })
    }
  </Fragment>
})

class VlpFolderBreadcrumbStore extends VipLocalStore {
  constructor(stores: StoresInstance, public folderIndex: number) {
    super(stores)
  }

  @computed get selectedAtIndex() {
    const {vlp: {hierarchy: {folderById}}, catalog: {seasonSelector: {selected: {folders}}}, folderIndex} = this
    return _.uniq(folders.filter(f => _.isArray(f) && f.length > folderIndex).map(f => f[folderIndex]).map(id => folderById[id])).filter(_.identity)
  }

  @computed get selectedAtIndexString() {
    const {selectedAtIndex, vlp: {hierarchy: {pathTitleForFolder}}} = this,
      grouped = _.groupBy(selectedAtIndex, f => pathTitleForFolder(f.parent?.id) ?? f.plan?.name)
    return _.flatMap(
        _.sortBy(_.keys(grouped)).map(k => _.sortBy(grouped[k].map(f => f.name))))
      .join(', ')
  }
}

const VlpFolderBreadcrumb = observer<{ index }>(function VlpFolderBreadcrumb({index}) {
  const {
      onClickBreadcrumb, getHierarchyIcon, onAddHierarchy, availableFoldersByDepth, isFolderSelected, onContextMenu, vlp,
      strings, catalog: {
        workspaceConfig: {addHierarchyItem},
        seasonSelector: {isLeafFolderSelected, _counts: {loading, folders: counts}, openBreadcrumb, onOpenBreadcrumb, onCloseBreadcrumb}, seasonSelector, customHierarchy
      },
      vlp: {hierarchy: {planById, folderById, pathTitleForFolder}}
    } = useSeasonSelectorStore(),
    store = useVipLocalStore((ws) => new VlpFolderBreadcrumbStore(ws, index)),
    {selectedAtIndex, selectedAtIndexString} = store,
    availableFolders = availableFoldersByDepth[index],
    availableByParent = _.groupBy(availableFolders, f => f.parent?.id ?? f.plan.exId),
    parents = _.keys(availableByParent).map(parentId => parentId && (folderById[parentId] ?? planById[parentId])).filter(_.identity),
    customVlpHierarchy = customHierarchy?.get(`Folder ${index + 1}`),
    customSortMap = new Map<string, number>((customVlpHierarchy?.customSort ?? []).map((cs, i) => [cs, i])),
    placeholder = customVlpHierarchy?.assignedName ?? `Folder ${index + 1}`


  // console.log(toJS({index, selectedAtIndex, selectedAtIndexString, availableFolders, availableByParent, parents}))

  if (_.isEmpty(availableFolders) && isLeafFolderSelected) return null

  return <Fragment>
    <KeyboardArrowRight/>
    <Popover2
      minimal
      //usePortal={false}
      interactionKind='hover'
      position='bottom-left'
      onOpening={onOpenBreadcrumb}
      isOpen={openBreadcrumb?.type == 'folder' && openBreadcrumb?.level == index}
      onInteraction={nextOpenState => {
        if (nextOpenState) {
          seasonSelector.openBreadcrumb = {type: 'folder', level: index}
        } else {
          seasonSelector.openBreadcrumb = null
        }
      }}
      onClose={onCloseBreadcrumb}
      content={
        <Menu
          className={classNames(
            css.menuItem
          )}
        >
          {_.isEmpty(availableFolders)
           ? <div className={css.notFoundText}>Folder {index + 1} not found</div>
           : _.orderBy(parents, p => { // First sort by parent name
              const path = pathTitleForFolder(p.id)
              return path
            }) // When we have multiple parent folders/plans divide them under separate headers sorted alphabetically
             .map(({id, name}) => {
               const ordered = _.orderBy(availableByParent[id], f => {
                   const path = pathTitleForFolder(f.id)
                   return path
                 }),
                 noneSelected = ordered.every(v => !isFolderSelected(v.exId))

               return (
                 <Fragment key={id}>
                   {_.size(parents) > 1 && <MenuDivider title={folderById[id]?.name}/>}
                   {_.orderBy(availableByParent[id], f => {
                       // YFTS-7953, YFTS-8560 Custom sort for arbitrary hierarchy items
                       if (customSortMap.has(f.name)) {
                         return customSortMap.get(f.name)
                       }

                       return f.name
                     })
                     .map(v => {
                       const icon = getHierarchyIcon(v.name)
                       return <MenuItem
                         key={v.exId}
                         data-id={v.exId}
                         text={v.name ? v.name : strings.noValue}
                         onContextMenu={onContextMenu(v, `FOLDER_${index}`)}
                         className={classNames(css.menuItem, noneSelected && css.noneSelected)}
                         shouldDismissPopover={parents.length === 1 && availableByParent[id].length === 1}
                         labelElement={counts && <div className={css.count}>({counts[v?.exId] ?? 0})</div>}
                         onClick={onClickBreadcrumb('folder', v, index, v.leaf)}
                         icon={
                           <Fragment>
                             {noneSelected || isFolderSelected(v.exId) ? <Icon icon='tick'/> : <Icon icon='blank'/>}
                             {icon && <LazyImage className={css.hierarchyIcon} src={icon.path}/>}
                           </Fragment>
                         }
                       />
                     })}
                 </Fragment>)
             })}
          {selectedAtIndex.length > 0 &&
		   <Fragment>
			   <MenuDivider/>
			   <MenuItem className={classNames(css.menuItem)} icon='clean' text={strings.clearSelection} onClick={() => vlp.hierarchy.clearFolderLevel(index)}/>
		   </Fragment>}
          {addHierarchyItem && _.size(parents) <= 1 && <Fragment>
              <MenuDivider/>
              <MenuItem key={`addFolder${index}`}
                        icon='add'
                        className={classNames(css.menuItem)} text={`New ${placeholder}`}
                        onClick={() => onAddHierarchy('folder', index)}/>
          </Fragment>}
        </Menu>
      }
    >
      <Button
        minimal
        text={
          !_.isEmpty(selectedAtIndex)
          ? selectedAtIndexString
          : _.isEmpty(availableFolders)
            ? `${placeholder} not found`
            : `<Choose ${placeholder}>`
        }
      />
    </Popover2>
  </Fragment>
})

const VlpCollectionBreadcrumb = observer(function VlpCollectionBreadcrumb() {
  const store = useSeasonSelectorStore(),
    {strings, onClickBreadcrumb, onAddHierarchy, dirty, selected, availableCollectionsByFolder, lastLevelFoldersCount, selectedCollections, selectedCollectionsString, collectionParentFolders, onContextMenu} = store,
    {
      vlp, vlp: {
      hierarchy: {folderById, lastSyncTimeMap, fetchLastSyncTime, fetchCollectionVersionCount}
    },
      catalog: {
        workspaceConfig: {syncIndicator}, workspaceConfig: {addHierarchyItem},
        seasonSelector: {_counts: {loading, collections: counts}, onOpenBreadcrumb, onCloseBreadcrumb, openBreadcrumb},
        seasonSelector, customHierarchy
      }
    } = useStores(),
    placeholder = customHierarchy?.get(`Collection`)?.assignedName ?? `Collection`

  useEffect(() => {
    fetchLastSyncTime('hierarchy')
    fetchCollectionVersionCount()
  }, [selectedCollections])

  // console.log(toJS({availableCollectionsByFolder, selectedCollections, selectedCollectionsString}))

  return (
    <Fragment>
      <KeyboardArrowRight/>
      <Popover2
        minimal
        // usePortal={false}
        position='bottom-left'
        interactionKind='hover'
        onOpening={onOpenBreadcrumb}
        isOpen={openBreadcrumb?.type == 'collection'}
        onInteraction={nextOpenState => {
          if (nextOpenState) {
            seasonSelector.openBreadcrumb = {type: 'collection'}
          } else if (seasonSelector.openBreadcrumb?.type === 'collection') {
            seasonSelector.openBreadcrumb = null
          }
        }}
        onClose={onCloseBreadcrumb}
        content={
          <Menu
            className={classNames(
              css.menuItem
            )}
          >
            {_.size(availableCollectionsByFolder) === 0
             ? <div className={css.notFoundText}>Collection not found</div>
             : collectionParentFolders.map(folderId => {
                const orderedCollections = _.orderBy(availableCollectionsByFolder[folderId], c => c.name),
                  noneSelected = orderedCollections.every(c => !_.includes(selected?.collections ?? [], c.exId))

                return <Fragment key={folderId}>
                  {_.size(availableCollectionsByFolder) > 1 && <MenuDivider key={folderId} title={folderById[folderId]?.name}/>}
                  {orderedCollections
                    .map(v => (
                      <MenuItem
                        key={v.exId}
                        shouldDismissPopover={collectionParentFolders.length === 1 && availableCollectionsByFolder[folderId].length === 1}
                        onContextMenu={onContextMenu(v, `collection`)}
                        data-id={v.exId}
                        text={v.name ? v.name : strings.noValue}
                        className={classNames(_.isEmpty(v) ? css.empty : css.menuItem, noneSelected && css.noneSelected)}
                        labelElement={counts && <div className={css.count}>({_.isEmpty(counts) && loading ? '...' : counts[v.id] ?? 0})</div>}
                        onClick={onClickBreadcrumb('collection', v)}
                        icon={noneSelected || _.includes(selected?.collections ?? [], v.exId) ? 'tick' : 'blank'}
                      />
                    ))}
                </Fragment>
              })}

            {collectionParentFolders.length > 1 && selectedCollections.length > 0 &&
			 <Fragment>
				 <MenuDivider/>
				 <MenuItem className={classNames(css.menuItemItem)} icon='clean' text={strings.clearSelection} onClick={() => vlp.hierarchy.selected.collections = []}/>
			 </Fragment>}
            {/*lastLevelFoldersCount === 1 && */
              addHierarchyItem && <Fragment> <MenuDivider/><MenuItem key={'addCollection'} className={classNames(css.menuItem)} icon='add' text={`New ${placeholder}`} onClick={() => onAddHierarchy('collection')}/> </Fragment>}
          </Menu>
        }
      >
        <Button
          minimal
          text={
            !_.isEmpty(selectedCollections)
            ? selectedCollectionsString
            : `Choose ${placeholder}`
          }
        />
      </Popover2>
      {!dirty && syncIndicator && !_.isEmpty(selectedCollections) && vlp &&
	   <HeaderSyncIndicator itemId={selectedCollections[0].exId} lastSyncTimeMap={lastSyncTimeMap} trigger={'hierarchy'}/> // todo - multiple collection support
      }

    </Fragment>
  )
})




// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/SeasonSelectorBreadcrumbs.tsx